import React from 'react';
import '../template-file-css/document-file-template.css';


export const LBS_PsychiatricEvaluation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LBS_PsychiatricEvaluation' className='file-pdf-document'>
            <div className='file-template'>
<table>
    <tr>
      <td className='w-375'>
         <span className='eleHeader'>Individual Accompany by:</span>
         <input type="text" name="txtIndividualAccompany" id="txtIndividualAccompany" className='add-only'/>
      </td>
      <td className='w-375'>
         <span className='eleHeader'>Relationship:</span>                        
         <input type="text" name="txtRelationship" id="txtRelationship" className='add-only'/>
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Method of Visit:</span>
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="radio" id="rbVisit_Yes" name="rbVisit" className='add-only' value="1" /> Face to Face                      
      </td>
      <td className='w-250'>
         <input type="radio" id="rbVisit_No" name="rbVisit" className='add-only' value="0" /> Telehealth/Telephonic
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Location of Visit:</span>
      </td>
   </tr>
   <tr>
      <td className='w-200'>
         <input type="radio" id="rbQuestions2_Yes" name="rbQuestions2" className='add-only' value="1" /> Office                       
      </td>
      <td className='w-200'>
         <input type="radio" id="rbQuestions2_No" name="rbQuestions2" className='add-only' value="0" /> Home
      </td>
      <td className='w-350'>
         <input type="radio" id="rbQuestions2_Nl" name="rbQuestions2" className='add-only' value="2" /> Other:
         <input type="text" name="txtPatient" id="txtPatient" className='add-only'/>
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-250'>
         <span className='eleHeader'>(Vitals) B/P:</span>
         <input type="text" name="txtVitals" id="txtVitals" className='add-only' />
      </td>
      <td className='w-250'>
         <span className='eleHeader'>Pulse:</span>                        
         <input type="text" name="txtPulse" id="txtPulse" className='add-only' />
      </td>
      <td className='w-250'>
         <span className='eleHeader'>Weight:</span>                        
         <input type="text" name="txtWeight" id="txtWeight" className='add-only' />
      </td>
   </tr>
</table>
<p className='w-750'>
   <span className='eleHeader'>REASON FOR REFERRAL AND CHIEF COMPLAINT:</span>
   <textarea id="txtDiagnosis" name="txtDiagnosis" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>PRESENTING PROBLEM:</span>
   <textarea id="txtDiagnosis1" name="txtDiagnosis1" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>HISTORY OF PRESENT ILLNESS:</span>
   <textarea id="txtDiagnosis2" name="txtDiagnosis2" className='add-only'></textarea>
</p>
<h4>
   HISTORY OF SYMPTOMS: BEHAVIORAL/EMOTIONAL STATUS <span className='small'>(Individual)</span>
</h4>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>General Appearance:</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance" id="chkAppearance" className='add-only' value="Aggressive"/>Aggressive
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance1" id="chkAppearance1" className='add-only' value="Frustrated"/>Frustrated easily
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance2" id="chkAppearance2" className='add-only' value="Sad"/>Sad/Crying
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance3" id="chkAppearance3" className='add-only' value="Truancy"/>Truancy
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance4" id="chkAppearance4" className='add-only' value="Mood"/>Mood Swings
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance5" id="chkAppearance5" className='add-only' value="Angry"/>Angry
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance6" id="chkAppearance6" className='add-only' value="Anxiety"/>Anxiety
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance7" id="chkAppearance7" className='add-only' value="Hallucinations"/>Hallucinations
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance8" id="chkAppearance8" className='add-only' value="Head"/>Head Banging
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance9" id="chkAppearance9" className='add-only' value="Fearful"/>Fearful
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance10" id="chkAppearance10" className='add-only' value="AnxietyP"/>PTSD
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance11" id="chkAppearance11" className='add-only' value="Lies"/>Lies frequently
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance12" id="chkAppearance12" className='add-only' value="Set"/>Set fires
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance13" id="chkAppearance13" className='add-only' value="Hurts"/>Hurts animals
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance14" id="chkAppearance14" className='add-only' value="Avoids"/>Avoids adults
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance15" id="chkAppearance15" className='add-only' value="Loner"/>Loner
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance16" id="chkAppearance16" className='add-only' value="Impulsive"/>Impulsive
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance17" id="chkAppearance17" className='add-only' value="Imaginary"/>Imaginary friends
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance18" id="chkAppearance18" className='add-only' value="Avoids"/>Sexual acting out
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance19" id="chkAppearance19" className='add-only' value="Bedwetting"/>Bedwetting
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance20" id="chkAppearance20" className='add-only' value="Short"/>Short attention span
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance21" id="chkAppearance21" className='add-only' value="Bizarre"/>Bizarre Behavior
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance22" id="chkAppearance22" className='add-only' value="Irritable"/>Irritable
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance23" id="chkAppearance23" className='add-only' value="Running"/>Running away
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance24" id="chkAppearance24" className='add-only' value="Hygiene"/>Hygiene/ADL's
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance25" id="chkAppearance25" className='add-only' value="Speech"/>Speech problems
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance26" id="chkAppearance26" className='add-only' value="Careless"/>Careless, reckless
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance27" id="chkAppearance27" className='add-only' value="Bullies"/>Bullies, threatens
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance28" id="chkAppearance28" className='add-only' value="Learning"/>Learning problems
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance29" id="chkAppearance29" className='add-only' value="Steals"/>Steals
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance30" id="chkAppearance30" className='add-only' value="Suicidal"/>Suicidal threats
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance31" id="chkAppearance31" className='add-only' value="Low"/>Low self-esteem
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance32" id="chkAppearance32" className='add-only' value="Hyperactivity"/>Hyperactivity
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance33" id="chkAppearance33" className='add-only' value="Talk"/>Talk back
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance34" id="chkAppearance34" className='add-only' value="Impulse"/>Impulse control
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance35" id="chkAppearance35" className='add-only' value="Nightmares"/>Nightmares
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance36" id="chkAppearance36" className='add-only' value="Defiant"/>Defiant
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance37" id="chkAppearance37" className='add-only' value="Destructive"/>Destructive
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance38" id="chkAppearance38" className='add-only' value="Oppositional"/>Oppositional
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance39" id="chkAppearance39" className='add-only' value="Panic"/>Panic attacks
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance40" id="chkAppearance40" className='add-only' value="Drug"/>Drug(s) dependence
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance41" id="chkAppearance41" className='add-only' value="Phobias"/>Phobias
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearance42" id="chkAppearance42" className='add-only' value="Loss"/>Loss of energy/Interests
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkAppearance44" id="chkAppearance44" className='add-only' value="Concerns"/>Other Concerns (Specify):
         <input type="text" id="txtAppearance44" name="txtAppearance44" className='add-only'/>
      </td>
   </tr>
</table>
<p className='w-750'>
   <span className='eleHeader'>Current Psychiatric Medications:</span>
   <textarea id="txtPsychiatricMedications" name="txtPsychiatricMedications" className='add-only'></textarea>
</p>
<h4>
   Medication Education:
</h4>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Verbal Medication Consent:</span>
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="radio" id="rbVerbal_Yes" name="rbVerbal" className='add-only' value="1" /> YES                       
      </td>
      <td className='w-250'>
         <input type="radio" id="rbVerbal_No" name="rbVerbal" className='add-only' value="0" /> NO
      </td>
      <td className='w-250'>
         <input type="radio" id="rbVerbal_Nl" name="rbVerbal" className='add-only' value="2" /> N/A
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkConsent1" id="chkConsent1" className='add-only' value="Consent"/>Name of medication(s), reason for prescribing, how to administer/take, time, frequency, amount & route
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-375'>
         <input type="checkbox" name="chkConsent2" id="chkConsent2" className='add-only' value="Side"/>Side Effects/Benefits/Adverse Reaction
      </td>
      <td className='w-375'>
         <input type="checkbox" name="chkConsent3" id="chkConsent3" className='add-only' value="Alcohol"/>Use of Alcohol/drug/tobacco interaction
      </td>
   </tr>
   <tr>
      <td className='w-375'>
         <input type="checkbox" name="chkConsent4" id="chkConsent4" className='add-only' value="Compliance"/>Compliance/Non-Compliance
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-250'>
         <span className='eleHeader'>OTC Medication(s):</span>
         <input type="text" name="txtMedication" id="txtMedication" className='add-only' />
      </td>
      <td className='w-250'>
         <span className='eleHeader'>Appetite:</span>                        
         <input type="text" name="txtAppetite" id="txtAppetite" className='add-only' />
      </td>
      <td className='w-250'>
         <span className='eleHeader'>Sleeping Patterns:</span>                        
         <input type="text" name="txtSleeping" id="txtSleeping" className='add-only' />
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <span className='eleHeader'>Motivation:</span>
         <input type="text" name="txtMotivation" id="txtMotivation" className='add-only' />
      </td>
   </tr>
</table>
<p className='w-750'>
   <span className='eleHeader'>Special Diet/Dietary Restrictions:</span>
   <textarea id="txtDiet" name="txtDiet" className='add-only'></textarea>
</p>
<table>
   <tr>
      <td className='w-375'>
         <input type="checkbox" name="chkChild1" id="chkChild1" className='add-only' value="Child"/>Child-bearing/pregnancy, if NOT applicable indicate -
      </td>
      <td className='w-375'>
         <input type="checkbox" name="chkChild2" id="chkChild2" className='add-only' value="NA"/>N/A
      </td>
   </tr>
</table>
<p className='w-750'>
   <span className='eleHeader'>PSYCHIATRIC HISTORY:</span>
   <textarea id="txtDiet2" name="txtDiet2" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>SIGNIFICANT PERSONAL, FAMILY, & SOCIAL HISTORY:</span>
   <textarea id="txtDiet3" name="txtDiet3" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>FAMILY PSYCHIATRIC AND MEDICAL/SURGICAL HISTORY:</span>
   <textarea id="txtDiet4" name="txtDiet4" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>FX HX:</span>
   <textarea id="txtDiet5" name="txtDiet5" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>MEDICAL HX/DIAGNOSIS/SURGERY HX/DEVELOPMENTAL HX:</span>
   <textarea id="txtDiet6" name="txtDiet6" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>Current Physical Medications:</span>
   <textarea id="txtDiet7" name="txtDiet7" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>Allergies:</span>
   <textarea id="txtAllergies" name="txtAllergies" className='add-only'></textarea>
</p>
<h4>
   SUBSTANCE USE HISTORY:
</h4>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Substance use/abuse history:</span>
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="radio" id="rbHistory_Yes" name="rbHistory" className='add-only' value="1" /> None reported                       
      </td>
      <td className='w-250'>
         <input type="radio" id="rbHistory_No" name="rbHistory" className='add-only' value="0" /> History Reported
      </td>
   </tr>
</table>
<p className='w-750'>
   <span className='eleHeader'>If yes specify:</span>
   <textarea id="txtAllergies2" name="txtAllergies2" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>LEGAL STATUS/HISTORY:</span>
   <textarea id="txtAllergies3" name="txtAllergies3" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>EMPLOYMENT STATUS/HISTORY:</span>
   <textarea id="txtAllergies4" name="txtAllergies4" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>EDUCATIONAL STATUS/HISTORY:</span>
   <textarea id="txtAllergies5" name="txtAllergies5" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>HOUSING STATUS/HISTORY:</span>
   <textarea id="txtAllergies6" name="txtAllergies6" className='add-only'></textarea>
</p>
<p className='w-750'>
   <span className='eleHeader'>(MENTAL STATUS EXAMINATION):</span>
   <textarea id="txtAllergies7" name="txtAllergies7" className='add-only'></textarea>
</p>
<h4>
   I. MENTAL STATUS EXAMINATION <span className='small'>(Circle or Check all that apply.)</span>
</h4>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>a. GENERAL APPEARANCE</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen" id="chkAppearanceGen" className='add-only' value="Healthy"/>Healthy;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen1" id="chkAppearanceGen1" className='add-only' value="Age"/>As stated Age;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen2" id="chkAppearanceGen2" className='add-only' value="Stated Age"/>Older Than Stated Age;  
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen3" id="chkAppearanceGen3" className='add-only' value="Young"/>Young-looking;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen4" id="chkAppearanceGen4" className='add-only' value="Tattoos"/>Tattoos;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen5" id="chkAppearanceGen5" className='add-only' value="Disheveled"/>Disheveled;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen6" id="chkAppearanceGen6" className='add-only' value="Unkempt"/>Unkempt;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen7" id="chkAppearanceGen7" className='add-only' value="Malodorous"/>Malodorous;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen8" id="chkAppearanceGen8" className='add-only' value="Thin"/>Thin;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen9" id="chkAppearanceGen9" className='add-only' value="Overweight"/>Overweight;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceGen10" id="chkAppearanceGen10" className='add-only' value="Obese"/>Obese;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkAppearanceGen11" id="chkAppearanceGen11" className='add-only' value="Describe"/>Other/Describe:
         <input type="text" id="txtAppearance" name="txtAppearance" className='add-only'/>
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>b. BEHAVIOR & PSYCHOMOTOR ACTIVITY</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkBehavior1" id="chkBehavior1" className='add-only' value="Normal"/>Normal;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkBehavior2" id="chkBehavior2" className='add-only' value="Overactive"/>Overactive;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkBehavior3" id="chkBehavior3" className='add-only' value="Hypoactive"/>Hypoactive;  
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkBehavior4" id="chkBehavior4" className='add-only' value="Catatonia"/>Catatonia;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkBehavior5" id="chkBehavior5" className='add-only' value="Tremor"/>Tremor;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkBehavior6" id="chkBehavior6" className='add-only' value="Tics"/>Tics;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkBehavior7" id="chkBehavior7" className='add-only' value="Combative"/>Combative;  
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkBehavior8" id="chkBehavior8" className='add-only' value="Other Describe"/>Other/Describe
         <input type="text" id="txtBehavior" name="txtBehavior" className='add-only'/>
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>c. ATTITUDE</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude" id="chkAttitude" className='add-only' value="Optimal"/>Optimal;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude1" id="chkAttitude1" className='add-only' value="Constructive"/>Constructive;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude2" id="chkAttitude2" className='add-only' value="Motivated"/>Motivated; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude3" id="chkAttitude3" className='add-only' value="Obstructive"/>Obstructive;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude4" id="chkAttitude4" className='add-only' value="Adversarial"/>Adversarial;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude5" id="chkAttitude5" className='add-only' value="Inaccessible"/>Inaccessible;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude6" id="chkAttitude6" className='add-only' value="Cooperative"/>Cooperative; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude7" id="chkAttitude7" className='add-only' value="Seductive"/>Seductive;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude8" id="chkAttitude8" className='add-only' value="Defensive"/>Defensive;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude9" id="chkAttitude9" className='add-only' value="Hostile"/>Hostile;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude10" id="chkAttitude10" className='add-only' value="Guarded"/>Guarded; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude11" id="chkAttitude11" className='add-only' value="Apathetic"/>Apathetic;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAttitude12" id="chkAttitude12" className='add-only' value="Evasive"/>Evasive;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkAttitude121" id="chkAttitude121" className='add-only' value="Explain"/>Other/Explain:
         <input type="text" id="txtSpeech41" name="txtSpeech41" className='add-only'/>
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>d. SPEECH</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech1" id="chkSpeech1" className='add-only' value="Normal"/>Normal;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech2" id="chkSpeech2" className='add-only' value="Spontaneous"/>Spontaneous;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech3" id="chkSpeech3" className='add-only' value="Slow"/>Slow; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech4" id="chkSpeech4" className='add-only' value="Impoverished"/>Impoverished;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech5" id="chkSpeech5" className='add-only' value="Hesitant"/>Hesitant;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech6" id="chkSpeech6" className='add-only' value="Monotonous"/>Monotonous;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech7" id="chkSpeech7" className='add-only' value="Whispered"/>Soft/Whispered; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech8" id="chkSpeech8" className='add-only' value="Mumble"/>Mumble;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech9" id="chkSpeech9" className='add-only' value="Rapid"/>Rapid;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech10" id="chkSpeech10" className='add-only' value="Pressured"/>Pressured;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech11" id="chkSpeech11" className='add-only' value="Verbose"/>Verbose; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech12" id="chkSpeech12" className='add-only' value="Loud"/>Loud;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech13" id="chkSpeech13" className='add-only' value="Slurred"/>Slurred;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSpeech14" id="chkSpeech14" className='add-only' value="Impediment"/>Impediment;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkSpeech15" id="chkSpeech15" className='add-only' value="Other"/>Other/Describe:
         <input type="text" id="txtSpeech52" name="txtSpeech52" className='add-only'/>
      </td>
    </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>e. MOOD:</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkMood1" id="chkMood1" className='add-only' value="Dysphoric"/>Dysphoric;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood2" id="chkMood2" className='add-only' value="Euthymic"/>Euthymic;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood3" id="chkMood3" className='add-only' value="Expansive"/>Expansive; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood4" id="chkMood4" className='add-only' value="Irritable"/>Irritable;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkMood5" id="chkMood5" className='add-only' value="Labile"/>Labile;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood6" id="chkMood6" className='add-only' value="Elevated"/>Elevated;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood7" id="chkMood7" className='add-only' value="Euphoric"/>Euphoric; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood8" id="chkMood8" className='add-only' value="Ecstatic"/>Ecstatic;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkMood9" id="chkMood9" className='add-only' value="Depressed"/>Depressed;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood10" id="chkMood10" className='add-only' value="Grief"/>Grief/mourning;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood11" id="chkMood11" className='add-only' value="Alexithymic"/>Alexithymic; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood12" id="chkMood12" className='add-only' value="Elated"/>Elated;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkMood13" id="chkMood13" className='add-only' value="Hypomanic"/>Hypomanic;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood14" id="chkMood14" className='add-only' value="Manic"/>Manic;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood141" id="chkMood141" className='add-only' value="Anxious"/>Anxious; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkMood15" id="chkMood15" className='add-only' value="Tense"/>Tense;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkMood16" id="chkMood16" className='add-only' value="Other"/>Other/Describe:
         <input type="text" id="txtMood1" name="txtMood1" className='add-only'/>
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>f. AFFECT</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceAff1" id="chkAppearanceAff1" className='add-only' value="Appropriate"/>Appropriate;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceAff2" id="chkAppearanceAff2" className='add-only' value="Inappropriate"/>Inappropriate;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceAff3" id="chkAppearanceAff3" className='add-only' value="Blunted"/>Blunted; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceAff4" id="chkAppearanceAff4" className='add-only' value="Restricted"/>Restricted;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceAff5" id="chkAppearanceAff5" className='add-only' value="Flat"/>Flat;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceAff6" id="chkAppearanceAff6" className='add-only' value="Labile"/>Labile;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceAff7" id="chkAppearanceAff7" className='add-only' value="Tearful"/>Tearful; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkAppearanceAff8" id="chkAppearanceAff8" className='add-only' value="Intense"/>Intense;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkAppearanceAff9" id="chkAppearanceAff9" className='add-only' value="Describe"/>Other/Describe:
         <input type="text" id="txtOtherDescribe231" name="txtOtherDescribe231" className='add-only'/>
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>g. PERCEPTUAL DISTURBANCES</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkDelusions1" id="chkDelusions1" className='add-only' value="None"/>None
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkDelusions2" id="chkDelusions2" className='add-only' value="Paranoid"/>Hallucinations:
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkDelusions3" id="chkDelusions3" className='add-only' value="Auditory"/>Auditory; 
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkDelusions4" id="chkDelusions4" className='add-only' value="Visual"/>Visual; 
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkHallucinations" id="chkHallucinations" className='add-only' value="Olfactory"/>Olfactory;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkHallucinations1" id="chkHallucinations1" className='add-only' value="Tactile"/>Tactile;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHallucinations2" id="chkHallucinations2" className='add-only' value="Other"/>Other/Describe: 
         <input type="text" id="txtOtherDescribe23" name="txtOtherDescribe23" className='add-only'/>
      </td>
    </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>h. THOUGHT PROCESS</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess1" id="chkProcess1" className='add-only' value="Logical"/>Logical/Coherent;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess2" id="chkProcess2" className='add-only' value="Incomprehensible"/>Incomprehensible;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess3" id="chkProcess3" className='add-only' value="Incoherent"/>Incoherent;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess4" id="chkProcess4" className='add-only' value="Flight"/>Flight of Ideas;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess5" id="chkProcess5" className='add-only' value="Associations"/>Loose Associations;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess6" id="chkProcess6" className='add-only' value="Tangential"/>Tangential;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess7" id="chkProcess7" className='add-only' value="Circumstantial"/>Circumstantial;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess8" id="chkProcess8" className='add-only' value="Rambling"/>Rambling;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess9" id="chkProcess9" className='add-only' value="Evasive"/>Evasive;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess10" id="chkProcess10" className='add-only' value="Racing"/>Racing Thoughts;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess11" id="chkProcess11" className='add-only' value="Perseveration"/>Perseveration;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess12" id="chkProcess12" className='add-only' value="Blocking"/>Thought Blocking;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkProcess13" id="chkProcess13" className='add-only' value="Concrete"/>Concrete;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkProcess14" id="chkProcess14" className='add-only' value="Describe"/>Other/Describe:
         <input type="text" id="txtProcess" name="txtProcess" className='add-only'/>
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>i. THOUGHT CONTENT</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal" id="chkSuicidal" className='add-only' value="Preoccupations"/>Preoccupations;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal1" id="chkSuicidal1" className='add-only' value="Obsessions"/>Obsessions;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal2" id="chkSuicidal2" className='add-only' value="Compulsions"/>Compulsions;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal3" id="chkSuicidal3" className='add-only' value="Phobias"/>Phobias;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal4" id="chkSuicidal4" className='add-only' value="Intentions"/>Delusions;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal5" id="chkSuicidal5" className='add-only' value="Thought"/>Thought Broadcasting;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal6" id="chkSuicidal6" className='add-only' value="Insertion"/>Thought Insertion;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal8" id="chkSuicidal8" className='add-only' value="Withdrawal"/>Thought Withdrawal;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal9" id="chkSuicidal9" className='add-only' value="Reference"/>Ideas of Reference;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal10" id="chkSuicidal10" className='add-only' value="Influence"/>Ideas of Influence;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSuicidal11" id="chkSuicidal11" className='add-only' value="Delusions1"/>Delusions;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHomicidal51" id="chkHomicidal51" className='add-only' value="Intentions2"/> Other/Describe:
         <input type="text" id="txtOtherDescribe24" name="txtOtherDescribe24" className='add-only'/>
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>j. SUICIDAL/HOMICIDAL IDEATION</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkHomicidal1" id="chkHomicidal1" className='add-only' value="Suicidal"/>Suicidal Thoughts;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkHomicidal2" id="chkHomicidal2" className='add-only' value="Attempts"/>Suicidal Attempts;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkHomicidal3" id="chkHomicidal3" className='add-only' value="Intent"/>Suicidal Intent;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkHomicidal4" id="chkHomicidal4" className='add-only' value="Plans"/>Suicidal Plans;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkHomicidal5" id="chkHomicidal5" className='add-only' value="Intentions2"/>History of
         Self-Injurious Behavior
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkHomicidal6" id="chkHomicidal6" className='add-only' value="Homicidal"/>Homicidal Thoughts;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkHomicidal7" id="chkHomicidal7" className='add-only' value="Homicidal2"/>Homicidal Attempts;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkHomicidal8" id="chkHomicidal8" className='add-only' value="Intent"/>Homicidal Intent;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHomicidal9" id="chkHomicidal9" className='add-only' value="Describe"/>Other/Describe:
         <input type="text" id="txtHomicidal" name="txtHomicidal" className='add-only'/>
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>k. SENSORIUM/COGNITION</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkSensorium" id="chkSensorium" className='add-only' value="Alert"/>Alert;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSensorium1" id="chkSensorium1" className='add-only' value="Lethargic"/>Lethargic;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSensorium2" id="chkSensorium2" className='add-only' value="Somnolent"/>Somnolent;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkSensorium3" id="chkSensorium3" className='add-only' value="Stuporous"/>Stuporous;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Oriented to:</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkOriented" id="chkOriented" className='add-only' value="Person"/>Person;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkOriented1" id="chkOriented1" className='add-only' value="Place"/>Place;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkOriented2" id="chkOriented2" className='add-only' value="Time"/>Time;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkOriented3" id="chkOriented3" className='add-only' value="Situation"/>Situation;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkOriented4" id="chkOriented4" className='add-only' value="Concentration"/>Normal Concentration;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkOriented5" id="chkOriented5" className='add-only' value="Impaired"/>Impaired Concentration;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkOriented6" id="chkOriented6" className='add-only' value="Describe5"/>Other/Describe:
         <input type="text" id="txtOriented" name="txtOriented" className='add-only'/>
      </td>
   </tr>
</table>
<h4>
   l. MEMORY
</h4>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Remote Memory:</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkRemoteMemory1" id="chkRemoteMemory1" className='add-only' value="Normal3"/>Normal;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkRemoteMemory2" id="chkRemoteMemory2" className='add-only' value="Impaired3"/>Impaired;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Recent Memory:</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkRemoteMemory3" id="chkRemoteMemory3" className='add-only' value="Normal1"/>Normal;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkRemoteMemory4" id="chkRemoteMemory4" className='add-only' value="Impaired1"/>Impaired;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Immediate Recall:</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkRemoteMemory5" id="chkRemoteMemory5" className='add-only' value="Normal2"/>Normal;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkRemoteMemory6" id="chkRemoteMemory6" className='add-only' value="Impaired2"/>Impaired;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkRemoteMemory7" id="chkRemoteMemory7" className='add-only' value="Other Describe"/>Other/Describe:
         <input type="text" id="txtImmediateRecall" name="txtImmediateRecall" className='add-only'/>
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>m. INTELLECTUAL FUNCTIONING</span><span className='small'> (Estimate)</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkFunctioning" id="chkFunctioning" className='add-only' value="Avg"/>Above Avg.;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkFunctioning1" id="chkFunctioning1" className='add-only' value="Normal"/>Normal/Avg.;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkFunctioning2" id="chkFunctioning2" className='add-only' value="Borderline"/>Borderline;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Mental Retardation:</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkRetardation1" id="chkRetardation1" className='add-only' value="Mild"/>Mild;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkRetardation2" id="chkRetardation2" className='add-only' value="Moderate"/>Moderate;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkRetardation3" id="chkRetardation3" className='add-only' value="Severe"/>Severe;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkRetardation" id="chkRetardation" className='add-only' value="Describe6"/>Other/Describe:
         <input type="text" id="txtRetardation" name="txtRetardation" className='add-only'/>
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>n. JUDGEMENT</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkJudgement1" id="chkJudgement1" className='add-only' value="Critical"/>Critical Judgment Intact;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkJudgement2" id="chkJudgement2" className='add-only' value="Impaired"/>Impaired Judgment;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkJudgement3" id="chkJudgement3" className='add-only' value="Describe6"/>Other/Describe:
         <input type="text" id="txtJudgement" name="txtJudgement" className='add-only'/>
      </td>
    </tr>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>o. INSIGHT</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkInsight1" id="chkInsight1" className='add-only' value="Emotional"/>True Emotional Insight;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkInsight2" id="chkInsight2" className='add-only' value="Intellectual"/>Intellectual Insight;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkInsight3" id="chkInsight3" className='add-only' value="Illness"/>Some Awareness of Illness/symptoms;
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="checkbox" name="chkInsight4" id="chkInsight4" className='add-only' value="Insight6"/>Impaired Insight;
      </td>
      <td className='w-187'>
         <input type="checkbox" name="chkInsight5" id="chkInsight5" className='add-only' value="Denial"/>Denial;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkInsight6" id="chkInsight6" className='add-only' value="Describe8"/>Other/Describe:
         <input type="text" id="txtInsight" name="txtInsight" className='add-only'/>
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>p. IMPULSE CONTROL</span>
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkImpulse1" id="chkImpulse1" className='add-only' value="Resist"/>Able to Resist Impulses;
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkImpulse2" id="chkImpulse2" className='add-only' value="Recent"/>Recent Impulsive Behavior;
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkImpulse3" id="chkImpulse3" className='add-only' value="IllnessControl"/>Impaired Impulse Control;
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkImpulse4" id="chkImpulse4" className='add-only' value="Compulsions"/>Compulsions;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkImpulse5" id="chkImpulse5" className='add-only' value="Denial"/>Other/Describe:
         <input type="text" id="txtImpulse" name="txtImpulse" className='add-only'/>
      </td>
   </tr>
</table>
<p className='w-750'>
   <strong>II. RISK ASSESSMENT:</strong> Assess potential risk of harm to self or others, including patterns of risk behavior and/or risk due to personality factors, substance
   use, criminogenic factors, exposure to elements, exploitation, abuse, neglect, suicidal or homicidal history, self-injury, psychosis, impulsiveness, etc.
</p>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>a. Risk of Harm to Self:</span>
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmSelf" id="chkHarmSelf" className='add-only' value="Prior"/>Prior Suicide Attempt;
      </td>
      <td className='w-200'>
         <input type="checkbox" name="chkHarmSelf1" id="chkHarmSelf1" className='add-only' value="Plan"/>Stated Plan/Intent;
      </td>
      <td className='w-300'>
         <input type="checkbox" name="chkHarmSelf2" id="chkHarmSelf2" className='add-only' value="Access"/>Access to means (weapons, pills, etc.);
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmSelf3" id="chkHarmSelf3" className='add-only' value="Recent"/>Recent Loss;
      </td>
      <td className='w-200'>
         <input type="checkbox" name="chkHarmSelf4" id="chkHarmSelf4" className='add-only' value="Terminal"/>Terminal Illness;
      </td>
      <td className='w-300'>
         <input type="checkbox" name="chkHarmSelf5" id="chkHarmSelf5" className='add-only' value="Family"/>Family History of Suicide; 
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmSelf6" id="chkHarmSelf6" className='add-only' value="Substance"/>Substance Abuse;
      </td>
      <td className='w-200'>
         <input type="checkbox" name="chkHarmSelf7" id="chkHarmSelf7" className='add-only' value="Psychosis"/>Psychosis;
      </td>
      <td className='w-300'>
         <input type="checkbox" name="chkHarmSelf8" id="chkHarmSelf8" className='add-only' value="Marked"/>Marked lack of support;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmSelf9" id="chkHarmSelf9" className='add-only' value="Behavioral"/>Presence of Behavioral Cues (isolation, giving away possessions, rapid mood swings, etc.);
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmSelf10" id="chkHarmSelf10" className='add-only' value="Acquaintance"/>Suicide of friend/acquaintance;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmSelf11" id="chkHarmSelf11" className='add-only' value="Describe"/>Other/Describe:
         <input type="text" id="txtHarmSelf111" name="txtHarmSelf111" className='add-only'/>
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>b. Risk of Harm to Others:</span>
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers1" id="chkHarmOthers1" className='add-only' value="Violence"/>Prior acts of violence;
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers2" id="chkHarmOthers2" className='add-only' value="Destruction"/>Destruction of property;
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers3" id="chkHarmOthers3" className='add-only' value="Access"/>Arrests for violence;
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers4" id="chkHarmOthers4" className='add-only' value="Access"/>Access to means (weapons);
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers5" id="chkHarmOthers5" className='add-only' value="Substance"/>Substance use;
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers6" id="chkHarmOthers6" className='add-only' value="Physically"/>Physically abused as child;
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers7" id="chkHarmOthers7" className='add-only' value="Abusive"/>Was physically abusive as a child;
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers8" id="chkHarmOthers8" className='add-only' value="Harms"/>Harms animals;
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers9" id="chkHarmOthers9" className='add-only' value="Fire"/>Fire setting;
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkHarmOthers10" id="chkHarmOthers10" className='add-only' value="Angry"/>Angry mood/agitation;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmOthers11" id="chkHarmOthers11" className='add-only' value="Hospitalizations"/>Prior hospitalizations for danger to others;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmOthers12" id="chkHarmOthers12" className='add-only' value="Psychosis"/>Psychosis/command hallucinations;
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmOthers13" id="chkHarmOthers13" className='add-only' value="Describe"/>Other/Describe:
         <input type="text" id="txtHarmSelf11" name="txtHarmSelf11" className='add-only'/>
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Summary of Risk Evaluation:</span>
      </td>
   </tr>
   <tr>
      <td className='w-187'>
         <input type="radio" id="rbEvaluation_Yes" name="rbEvaluation" className='add-only' value="1" /> None
      </td>
      <td className='w-187'>
         <input type="radio" id="rbEvaluation_Ys" name="rbEvaluation" className='add-only' value="0" /> Low
      </td>
      <td className='w-187'>
         <input type="radio" id="rbEvaluation_Ye" name="rbEvaluation" className='add-only' value="2" /> Moderate
      </td>
      <td className='w-187'>
         <input type="radio" id="rbEvaluation_Yel" name="rbEvaluation" className='add-only' value="3" /> Imminent
      </td>
   </tr>
</table>
<p className='w-750'>
   <span className='eleHeader'>DIAGNOSTIC IMPRESSIONS:</span>
   <textarea id="txtDiagnosis34" name="txtDiagnosis34" className='add-only'></textarea>
</p>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>TREATMENT PLAN: DSM -5 Criteria (Indicate all applicable DSM-5 Criteria in justifying diagnosis (es):  </span>
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria1" id="chkHarmCriteria1" className='add-only' value="Hyperactivity1"/><strong>ADHD - </strong>  Hyperactivity, impulse control, focus/concentration
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria2" id="chkHarmCriteria2" className='add-only' value="Hyperactivity2"/><strong>ODD -</strong> Aggression, impulse control
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria3" id="chkHarmCriteria3" className='add-only' value="Hyperactivity3"/><strong>Intermittent Explosive Disorder/Disruptive Impulse Control -</strong> anger, aggression, impulse control, depression
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria4" id="chkHarmCriteria4" className='add-only' value="Hyperactivity4"/><strong>Conduct Disorder -</strong> Aggression, anger, impulse control
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria5" id="chkHarmCriteria5" className='add-only' value="Hyperactivity5"/><strong>Depressive Disorders -</strong> Mood regulation
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria6" id="chkHarmCriteria6" className='add-only' value="Hyperactivity6"/><strong>Mood Dysregulation Disorder -</strong> Mood regulation
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria7" id="chkHarmCriteria7" className='add-only' value="Hyperactivity7"/><strong>Anxiety & Phobia related disorders -</strong> Irritability, concentration, restlessness, anxiousness
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria8" id="chkHarmCriteria8" className='add-only' value="Hyperactivity8"/><strong>PTSD &other trauma related disorders -</strong> Agitation, irritability, hypervigilance, anxiety
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria9" id="chkHarmCriteria9" className='add-only' value="Hyperactivity9"/><strong>Bipolar -</strong> Mania & Mood stabilization
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria10" id="chkHarmCriteria10" className='add-only' value="Hyperactivity10"/><strong>Schizophrenia Spectrum & Other psychotic disorders -</strong> Psychosis stabilization
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria11" id="chkHarmCriteria11" className='add-only' value="Hyperactivity11"/><strong>OCD -</strong> Agitation, hypervigilance, fear, compulsions, rumination & anxiousness
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkHarmCriteria12" id="chkHarmCriteria12" className='add-only' value="Hyperactivity12"/><strong>Substance Related Disorders: (Referral information):</strong> <input type="text" id="txtReferral" name="txtReferral" className='add-only'/>
      </td>
   </tr>
</table>
<table>
   <tr>
      <td className='w-750'>
         <span className='eleHeader'>Recommended Services:</span>
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkRecommendedServices1" id="chkRecommendedServices1" className='add-only' value="Skills"/>Skills Training and Development
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkRecommendedServices2" id="chkRecommendedServices2" className='add-only' value="DestructionP"/>PSR
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkRecommendedServices3" id="chkRecommendedServices3" className='add-only' value="Targeted"/>Targeted Case Management
      </td>
   </tr>
   <tr>
      <td className='w-250'>
         <input type="checkbox" name="chkRecommendedServices4" id="chkRecommendedServices4" className='add-only' value="Crisis"/>Crisis Intervention
      </td>
      <td className='w-250'>
         <input type="checkbox" name="chkRecommendedServices5" id="chkRecommendedServices5" className='add-only' value="Medication"/>Medication Training and Support Management:
      </td>
   </tr>
   <tr>
      <td className='w-750'>
         <input type="checkbox" name="chkRecommendedServices6" id="chkRecommendedServices6" className='add-only' value="Specify"/>Other (Specify):
         <input type="text" id="txtRecommendedServices" name="txtRecommendedServices" className='add-only'/>
      </td>
   </tr>
</table>
<h4>
   New Medication(s) prescribed:
</h4>
<table>
   <tr>
      <td className='w-200'>
         <span className='eleHeader'>Name of Medications</span>
      </td>
      <td className='w-150'>
         <span className='eleHeader'>Dose/Strength</span> 
      </td>
      <td className='w-400'>
         <span className='eleHeader'>What is this medication used to treat?</span>  
      </td>
   </tr>
   <tr>
      <td className='w-200'>
         <input type="text" name="txtMedications" id="txtMedications" className='add-only'/>
      </td>
      <td className='w-150'>                       
         <input type="text" name="txtStrength" id="txtStrength" className='add-only'/>
      </td>
      <td className='w-400'>                    
         <input type="text" name="txtPulseDose" id="txtPulseDose" className='add-only'/>
      </td>
   </tr>
   <tr>
      <td className='w-200'>
         <input type="text" name="txtMedications1" id="txtMedications1" className='add-only'/>
      </td>
      <td className='w-150'>                       
         <input type="text" name="txtStrength1" id="txtStrength1" className='add-only'/>
      </td>
      <td className='w-400'>                    
         <input type="text" name="txtPulseDose1" id="txtPulseDose1" className='add-only'/>
      </td>
   </tr>
   <tr>
      <td className='w-200'>
         <input type="text" name="txtMedications2" id="txtMedications2" className='add-only'/>
      </td>
      <td className='w-150'>                       
         <input type="text" name="txtStrength2" id="txtStrength2" className='add-only'/>
      </td>
      <td className='w-400'>                    
         <input type="text" name="txtPulseDose2" id="txtPulseDose2" className='add-only'/>
      </td>
   </tr>
</table>
<table>
    <tr>
        <td className='signature w-375'>&nbsp; </td>
        <td className='signature w-375'>&nbsp; </td>
    </tr>
   <tr>
       <td className='small w-375'>Psychiatrist Signature</td>
       <td className='small w-375'>Date</td>
   </tr>
</table>
<p className='w-750'>
<span className='eleHeader'>Follow-up Plan/Return Date:</span><input type="text" name="txtReturnDate" id="txtReturnDate" className='add-only'/>
</p>
            </div>
        </form>
    )
}
